var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"staffQuestionWrapper"},[_c(_vm.component.type,_vm._b({tag:"component",on:{"input":function($event){return _vm.onInput($event)}}},'component',_vm.component.props || {},false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }